import { showLastQuestion } from "../actions/question/showLastQuestion";
import { prepareSubmitFormData } from "../actions/question/prepareSubmitFormData";

import { storage } from "../helpers/storage";

/**
 * Save quiz data
 */
document.addEventListener('growtypeQuizSaveQuizData', saveQuizDataListener)

function dispatchSaveFailed(quizId, reason) {
    document.dispatchEvent(new CustomEvent('growtypeQuizSaveFailed', {
        detail: {
            id: quizId,
            reason: reason
        }
    }));
}

function saveQuizDataListener(data) {
    let quizId = data['detail']['id'];
    let quizWrapper = $('.growtype-quiz-wrapper[id="' + quizId + '"]');

    if (!quizWrapper.find('.growtype-quiz').attr('data-save-answers')) {
        return false;
    }

    const answers = data.detail.answers && Object.entries(data.detail.answers).length > 0 ? data.detail.answers : null;
    const extraDetails = data.detail.extra_details && Object.entries(data.detail.extra_details).length > 0 ? data.detail.extra_details : null;
    const showLastQuestionOnError = false;

    let formData = prepareSubmitFormData(quizId, answers, extraDetails);

    /**
     * Save extra data to answers
     */
    $.ajax({
        url: growtype_quiz_local.ajax_url,
        type: "post",
        processData: false,
        contentType: false,
        cache: false,
        enctype: 'multipart/form-data',
        data: formData,
        beforeSend: function () {
        },
        success: function (data) {
            if (data.success) {
                /**
                 * Save data to local storage
                 */
                storage.set("growtype_quiz_unique_hash", data.unique_hash);

                /**
                 * Set unique hash if input exists
                 */
                if (quizWrapper.find('input[name="growtype_quiz_unique_hash"]').length > 0) {
                    quizWrapper.find('input[name="growtype_quiz_unique_hash"]').val(data.unique_hash);
                }

                /**
                 * Save data to local storage
                 */
                storage.set("growtype_quiz_answers", JSON.stringify(answers));

                /**
                 * Redirect url
                 */
                let redirectUrl = data.redirect_url !== null && data.redirect_url.length > 0 ? data.redirect_url : data.results_url;

                document.dispatchEvent(new CustomEvent('growtypeQuizSaved', {
                    detail: {
                        id: quizId,
                        answers: answers || {},
                        response: data
                    }
                }));

                if (quizWrapper.find('.growtype-quiz').attr('data-redirect-on-complete') === 'false') {
                    return;
                }

                /**
                 * Update loader
                 */
                setTimeout(function () {
                    if (quizWrapper.find('.growtype-quiz-loader-wrapper:visible').length > 0) {
                        if (redirectUrl && redirectUrl.length > 0) {
                            const loaderWrapper = quizWrapper.find('.growtype-quiz-loader-wrapper');

                            if (!loaderWrapper.attr('data-redirect-url') || loaderWrapper.attr('data-redirect-url').length === 0) {
                                loaderWrapper.attr('data-redirect-url', redirectUrl);
                            }

                            loaderWrapper.find('.btn-continue').attr('href', redirectUrl);
                        }
                    } else {
                        if (redirectUrl && redirectUrl.length > 0) {
                            window.location.replace(redirectUrl);
                        }
                    }
                }, 500)
            } else {
                dispatchSaveFailed(quizId, 'server_rejected');

                if (showLastQuestionOnError) {
                    showLastQuestion(answers);
                }
            }
        },
        error: function (data) {
            dispatchSaveFailed(quizId, 'request_failed');

            /**
             * Set quiz as not finished
             * @type {boolean}
             */
            window.growtype_quiz_global[quizId]['is_finished'] = false;

            if (showLastQuestionOnError) {
                showLastQuestion(answers, false);
            } else if (data['responseJSON'] && data['responseJSON']['message'] !== undefined) {
                console.error(data['responseJSON']['message']);
            }

            if (quizWrapper.find('.growtype-quiz-question.is-active').attr('data-hide-back-button') !== 'true') {
                quizWrapper.find('.growtype-quiz-wrapper .growtype-quiz-btn-go-back').attr('disabled', false).fadeIn();
            }
        }
    })
}
